module.exports = __webpack_public_path__ + "media/img/wedding_success/room-0ac67414335b3ab4b05d1f65ab6d8101.png";